import party from 'party-js'

const initButtonEffect = () => {
  party.resolvableShapes.cookie = '<span>🍪</span>'
  const button = document.querySelector('.cookiebanner__button--cookie-effect')

  button.addEventListener('click', function (e) {
    party.sparkles(this, {
      shapes: ['cookie'],
      count: party.variation.range(4, 7),
      lifetime: party.variation.range(0.7, 1),
      speed: party.variation.range(50, 100)
    })
  })
}

export default initButtonEffect
